import type { PaletteColor } from "@brexhq/metal-foundation";

import { BreakPointVals } from "@brexhq/shared/styles/breakpoints";
import { SemanticTextTag } from "@brexhq/shared/types/Typography";

import { FontWeightOverride } from "./Text";

export type FontWeights = 400 | 500 | 600;

export interface BaseTextProps {
  /** HTML element to render - default depends on typography component */
  as: SemanticTextTag;
  /** Color of type - defaults to contentPrimary */
  color?: PaletteColor | "inherit" | string;
  /** Optional Margin Options for text component*/
  margin?: MarginOptions;
  /** Optional gradient to use instead of color */
  gradient?: string;
  className?: string;

  fontWeightOverride?: FontWeightOverride;
}

export type TextProps = Partial<BaseTextProps>;

type RespTextObject = {
  lineHeight: string;
  fontSize: number;
  letterSpacing?: string;
};

type PolishedParams = Array<string | number | null>;

export type MarginOptions = {
  LRG?: PolishedParams;
  MED?: PolishedParams;
  SML?: PolishedParams;
};

export type ResponsiveArgs = {
  [Key in BreakPointVals]: RespTextObject;
};

export type ListProps = {
  type?: "Caption" | "BodySmall" | "BodyLarge";
  color?: PaletteColor;
};

export function isGradientColor(value?: string | null): value is GradientColor {
  return typeof value === "string" && value.startsWith("gradient");
}

export const gradientColors = [
  "gradientPurpleOrange",
  "gradientPeachCyan",
  "gradientBlue",
  "gradientAI",
] as const;

export const textColors = [
  "textPrimary",
  "textSecondary",
  "accent",
  ...gradientColors,
] as const;

type GradientColor = typeof gradientColors[number];

export type TextColor = typeof textColors[number];
